/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S19_HeadingInputs */

const tr_mesafeli_s19_heading = /** @type {(inputs: Mesafeli_S19_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19. Delil Sözleşmesi`)
};

const en_mesafeli_s19_heading = /** @type {(inputs: Mesafeli_S19_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19. Evidence Agreement`)
};

const de_mesafeli_s19_heading = /** @type {(inputs: Mesafeli_S19_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19. Beweisvereinbarung`)
};

const ru_mesafeli_s19_heading = /** @type {(inputs: Mesafeli_S19_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19. Соглашение о доказательствах`)
};

/**
* | output |
* | --- |
* | "19. Evidence Agreement" |
*
* @param {Mesafeli_S19_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s19_heading = /** @type {((inputs?: Mesafeli_S19_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S19_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s19_heading(inputs)
	if (locale === "de") return de_mesafeli_s19_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s19_heading(inputs)
	return tr_mesafeli_s19_heading(inputs)
});